import api from './api';

function unwrapResponse(response) {
  if (response && Object.prototype.hasOwnProperty.call(response, 'data')) {
    return response.data;
  }

  return response || {};
}

export const taskPaymentsService = {
  /**
   * Создать или получить уже существующий активный платёж задачи.
   */
  createForTask: async (
    taskId,
    title,
    {
      workAmount = 0,
      equipmentAmount = 0,
    } = {}
  ) => {
    const normalizedTaskId = Number(taskId);
    const normalizedTitle = String(title || '').trim();

    if (!Number.isInteger(normalizedTaskId) || normalizedTaskId <= 0) {
      throw new Error('Некорректный ID задачи');
    }

    if (!normalizedTitle) {
      throw new Error('Не указано назначение платежа');
    }

    const response = await api.post(
      `/task-payments/tasks/${normalizedTaskId}`,
      {
        title: normalizedTitle,
        work_amount: Number(workAmount || 0),
        equipment_amount: Number(equipmentAmount || 0),
      }
    );

    return unwrapResponse(response);
  },

  /**
   * Получить последний платёж задачи из CRM.
   */
  getForTask: async (taskId) => {
    const normalizedTaskId = Number(taskId);

    if (!Number.isInteger(normalizedTaskId) || normalizedTaskId <= 0) {
      throw new Error('Некорректный ID задачи');
    }

    const response = await api.get(
      `/task-payments/tasks/${normalizedTaskId}`
    );

    return unwrapResponse(response);
  },

  /**
   * Принудительно запросить актуальный статус у Savel Pay.
   */
  check: async (paymentId) => {
    const normalizedPaymentId = Number(paymentId);

    if (
      !Number.isInteger(normalizedPaymentId) ||
      normalizedPaymentId <= 0
    ) {
      throw new Error('Некорректный ID платежа');
    }

    const response = await api.post(
      `/task-payments/${normalizedPaymentId}/check`
    );

    return unwrapResponse(response);
  },
};

export default taskPaymentsService;
